// Module
var code = "<a class=\"instructionsLink\" target=\"_blank\"> <slot></slot> </a> ";
// Exports
export default code;